function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M12.008 15.067c.932 0 1.69-.773 1.69-1.725H10.31c0 .944.758 1.725 1.698 1.725zM8.22 11.2c-.577 0-1.047.48-1.047 1.067h2.092c0-.588-.462-1.067-1.046-1.067zM15.796 11.2c-.576 0-1.046.48-1.046 1.067h2.092c0-.588-.463-1.067-1.046-1.067zM12.008 6.118a.657.657 0 00.651-.657.658.658 0 00-.651-.666.662.662 0 000 1.323z"
}), React.createElement("path", {
  d: "M19.327 12.12a40.45 40.45 0 00-.629-3.272c-.227-.974-1.038-1.67-2.015-1.732a74.556 74.556 0 00-4.675-.132c-2.122 0-3.713.07-4.675.132-.978.062-1.789.758-2.016 1.732-.19.82-.454 2.05-.629 3.272a38.93 38.93 0 00-.288 2.893c-.038.611.16 1.199.561 1.655a2.16 2.16 0 001.553.75c1.319.062 3.342.14 5.501.14 2.16 0 4.183-.078 5.501-.14a2.204 2.204 0 001.553-.75 2.273 2.273 0 00.561-1.655 42.088 42.088 0 00-.303-2.893zm-1.046 3.837c-.212.24-.5.379-.818.394-1.31.062-3.311.14-5.455.14-2.145 0-4.145-.078-5.456-.14a1.183 1.183 0 01-1.114-1.269c.069-1.067.16-2.01.28-2.807.167-1.183.425-2.382.614-3.18a1.177 1.177 0 011.069-.92 72.442 72.442 0 014.614-.131c2.091 0 3.667.07 4.615.132.515.03.947.402 1.068.92.182.797.44 1.996.614 3.179.113.797.204 1.74.28 2.808 0 .325-.106.634-.31.874z"
}));

var SvgServiceLogoBitriseIcon = function SvgServiceLogoBitriseIcon(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgServiceLogoBitriseIcon;